
import Getstarted1 from '../components/gettingStarting/Getstarted';
import tos1 from '../components/gettingStarting/Termspage';
import Layout from '../components/Layout/Layout';
import Onboarding1 from '../components/gettingStarting/Onboarding';
import CommunityList from '../components/gettingStarting/CommunityList';
import Welcomemsgpage1 from '../components/gettingStarting/Welcomemsgpage';
import Onboardingslider from '../components/gettingStarting/Onboardingslider';
import OnboardingRegVertical from '../components/gettingStarting/OnboardingRegVertical';
import Thankspage1 from '../components/gettingStarting/Thankspage';
import customswipeslide from '../components/gettingStarting/customswipeslide';

// import Fox from '../components/Fox/Fox';
// import Layout2 from '../components/Template2/Layout/Layout';
// import template2 from '../components/Template2/gettingStarting/Onboarding';
// import Templat2Thankspage1 from '../components/Template2/gettingStarting/Thankspage';
// import Templat2Tos from '../components/Template2/gettingStarting/Termspage';

// Some folks find value in a centralized route config.
// A route config is just data. React is great at mapping
// data into components, and <Route> is a component.

// Our route config is just an array of logical "routes"
// with `path` and `component` props, ordered the same
// way you'd do inside a `<Switch>`.
const routes = [
    {
        path: "/CommunityList",
        name: "CommunityList",
        component: CommunityList
    },
    {
        path: "/Onboarding",
        name: "Onboarding",
        component: Onboarding1
    },
    {
        path: "/Welcomemsgpage1",
        name: "Welcomemsgpage1",
        component: Welcomemsgpage1
    },
    {
        path: "/Onboardingslider",
        name: "Onboardingslider",
        component: Onboardingslider
    },
    {
        path: "/OnboardingRegVertical",
        name: "OnboardingRegVertical",
        component: OnboardingRegVertical
    },
    {
        path: "/Thankspage1",
        name: "Thankspage1",
        component: Thankspage1
    },
    {
        path: "/Getstarted",
        name: "Getstarted",
        component: Getstarted1
    },
    {
        path: "/tos1",
        name: "tos1",
        component: tos1
    },
    // {
    //     path: "/tos",
    //     name: "tos",
    //     component: tos
    // },
    {
        path: "/Layout",
        name: "Layout",
        component: Layout
    },
    // {
    //     path: "/template2",
    //     name: "template2",
    //     component: template2
    // },
    // {
    //     path: "/Layout2",
    //     name: "Layout2",
    //     component: Layout2
    // },
    // {
    //     path: "/Templat2Thankspage1",
    //     name: "Templat2Thankspage1",
    //     component: Templat2Thankspage1
    // },
    // {
    //     path: "/Templat2Tos",
    //     name: "Templat2Tos",
    //     component: Templat2Tos
    // },
    {
        path: "/customswipeslide",
        name: "customswipeslide",
        component: customswipeslide
    },
    
    // {
    //     path: "/fox",
    //     name: "Fox",
    //     component: Fox
    // },
    {
        default: '/',
        component: CommunityList
    },

];

export default routes;